__turbopack_context__.v({
  "copiedText": "URLShareDialog-module-scss-module__YDVwKa__copiedText",
  "copy": "URLShareDialog-module-scss-module__YDVwKa__copy",
  "platformList": "URLShareDialog-module-scss-module__YDVwKa__platformList",
  "platformListItem": "URLShareDialog-module-scss-module__YDVwKa__platformListItem",
  "platformListItemIcon": "URLShareDialog-module-scss-module__YDVwKa__platformListItemIcon",
  "platformListItemLink": "URLShareDialog-module-scss-module__YDVwKa__platformListItemLink",
  "share": "URLShareDialog-module-scss-module__YDVwKa__share",
  "shareButton": "URLShareDialog-module-scss-module__YDVwKa__shareButton",
  "shareDialog": "URLShareDialog-module-scss-module__YDVwKa__shareDialog",
  "shareLinkCopy": "URLShareDialog-module-scss-module__YDVwKa__shareLinkCopy",
});
